module.exports = __webpack_public_path__ + "static/media/container-ship.d5f584c2.jpg";